import { render, staticRenderFns } from "./DummyVideoPresenceTable.vue?vue&type=template&id=9a41ca96&"
import script from "./DummyVideoPresenceTable.vue?vue&type=script&lang=js&"
export * from "./DummyVideoPresenceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports